import { BillingReturn } from '../subscriptions/BillingReturn';
import { useSubscriptionStore } from '../subscriptions';
import { authorizedFetch } from '@nimbitlabs/ui';

export function BillingReturnPage() {
  const { invalidateAll } = useSubscriptionStore();

  const handleVerifyPayment = async (reference: string) => {
    await authorizedFetch(`/subscriptions/verify/${reference}`, {
      method: 'POST',
    });
    
    // Invalidate all subscription queries after verification
    await invalidateAll();
  };

  const handlePollSubscription = async () => {
    try {
      const response = await authorizedFetch('/subscriptions/active');
      const subscription = await response.json();
      
      return { status: subscription?.status || 'inactive' };
    } catch {
      return { status: 'inactive' };
    }
  };

  return (
    <BillingReturn
      onVerifyPayment={handleVerifyPayment}
      onPollSubscription={handlePollSubscription}
      settingsPath="/subscription"
      dashboardPath="/dashboard"
    />
  );
}
